import React, { Fragment, ReactElement, useRef } from "react"
import { AddressAvailability } from "types/agenda.types"
import { AgendaSelector } from "./AgendaSelector/AgendaSelector"
import { KeeperVacation } from "types/keeper.types"

interface AgendaProps {
  agendaList: AddressAvailability[]
  vacation: KeeperVacation
}

export function Agenda({ agendaList, vacation }: AgendaProps): ReactElement {
  const agendaSelectorRef = useRef()

  return (
    <Fragment>
      <AgendaSelector
        ref={agendaSelectorRef}
        agenda={agendaList}
        onAvailabilitiesUpdated={() => true}
        vacation={vacation}
        // onInvalidAvailibilityPressed={() => true}
      />
    </Fragment>
  )
}
